import { useEffect, useState } from "react";
import { api } from "@/lib/auth";
import { moonTonight } from "./MoonRitual";

export default function MoonGlow() {
  const [on, setOn] = useState(false);
  useEffect(() => {
    if (moonTonight() !== "full" || !process.env.REACT_APP_BACKEND_URL) return undefined;
    let alive = true;
    api.get("/site-settings")
      .then(({ data }) => alive && setOn(data?.moon_glow !== false))
      .catch(() => alive && setOn(true));
    return () => {
      alive = false;
    };
  }, []);
  if (!on) return null;
  return (
    <div data-testid="moonlit-glow" aria-hidden="true" className="pointer-events-none fixed inset-0 z-[5] overflow-hidden">
      <div className="moonlit-orb absolute -top-[30vmax] right-[-20vmax] w-[80vmax] h-[80vmax] rounded-full bg-[radial-gradient(circle,rgba(226,232,244,0.22)_0%,rgba(200,210,230,0.08)_35%,transparent_65%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_120%,rgba(210,218,236,0.05),transparent_60%)]" />
    </div>
  );
}
